import * as React from "react";

const ratios = {
    "cinema" : 56.25,
    "classic" : 75,
    "pano" : 60,
    "portrait" : 100
};

interface MediaProps {
    name: string;
    ext: string;
    ratio?: "classic" | "pano" | "cinema" | "portrait";
}

interface MediaState {
    media: any;
}

class Media extends React.Component<MediaProps, MediaState> {

    state = {
        media: null
    };
    
    async componentDidMount() {
        const { ext, name } = this.props;
        await this.addMedia(`${name}.${ext}`);
    }

    async componentWillReceiveProps(newProps: MediaProps) {
        const { ext, name } = newProps;
        await this.addMedia(`${name}.${ext}`);
    }

    public render() {
        const { media } = this.state;
        const { ratio } = this.props;
        return (
            // tslint:disable-next-line:jsx-alignment
            <div style={{
                background: `url(${media}) no-repeat center center / cover`,
                paddingTop: `${ratios[ratio ? ratio : "classic"]}%`
                }} 
            />
        );
    }

    async addMedia (file: string) {
        import(`./assets/${file}`)
            .then(image =>
                this.setState({
                    media: image
                })
            )
            .catch(error => {
                window.console.error(`"${file}" not found`);
            });
    }

}

export default Media;


// WEBPACK FOOTER //
// ./src/components/Media/Media.tsx